//import { useFrame } from '@react-three/fiber'
import React, { useRef } from 'react';

export default function GlobeOne(props) {
  const mesh = useRef();
  return (
    <mesh ref={mesh}
      scale={[1, 1, 1]}
      position={props.position}>
      <sphereBufferGeometry args={[1, 20, 20]} />
      <meshBasicMaterial attach="material" map={props.texture} opacity="6"/>
    </mesh>
  );
}
